import React from 'react'
import PropTypes from 'prop-types'
import { UncheckAllIcon, CheckAllIcon } from 'src/components/icons'
import { LocalizedText } from 'src/components/intl'
import { useHandler } from 'src/hooks'
import IconAction from '../IconAction'

export default function SelectAllIconAction({ data, value, onChange, ...props }) {
  const selected = value.length === data.length
  const onClick = useHandler(e => e.preventDefault() || e.stopPropagation() || onChange(selected ? [] : data))

  return (
    <IconAction
      icon={selected ? UncheckAllIcon : CheckAllIcon}
      tooltip={<LocalizedText id={selected ? 'WEB_UNSELECT_ALL' : 'WEB_SELECT_ALL'} />}
      tooltipPlacement="top"
      onClick={onClick}
      {...props}
    />
  )
}

SelectAllIconAction.propTypes = {
  data: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
}
